export default __webpack_public_path__ + "static/media/slider4.6fb528e3.png";